import React from "react";
import { Typography, Drawer, Row, Col, Table, Tooltip } from "antd";
import moment from "moment";
import DateWithWeekday from "./DateWithWeekday";

export default class PriceDetailDrawer extends React.Component {

    hide = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }
    formatterYesOrNo = (text, record, index) => {
        return text ? <span style={{ color: 'green' }}>是</span> : "否";
    }
    // 走共用元件才會一併標出特別假日與補班日 —— 這張表就是在比對逐日房價，
    // 「這天是不是連假」正是判讀價格差異的關鍵
    formatterDate = (text) => <DateWithWeekday date={moment(text).format("YYYY-MM-DD")} />
    formatterTooltip = (text) => {
        return <Tooltip placement="topLeft" title={text}>
            {text}
        </Tooltip>;
    }
    formatterUrl = (text, record) => {
        return <div>
            <a href={record.html_url} target="_blank" rel="noopener noreferrer">HTML</a>  /
            <a href={record.json_url} target="_blank" rel="noopener noreferrer">JSON</a>
        </div>;
    }
    render() {
        const columns = [
            {
                title: "日期",
                dataIndex: "date",
                // fixed: 'left', 
                width: 150,
                sorter: (a, b) => new Date(a.date) - new Date(b.date),
                defaultSortOrder: 'ascend',
                render: this.formatterDate
            },
            {
                title: "飯店",
                dataIndex: "hotel_name",
                width: 150,
                ellipsis: { showTitle: false },
                render: this.formatterTooltip
            },
            {
                title: "房型",
                dataIndex: "roomtype_name",
                width: 150,
                ellipsis: { showTitle: false },
                render: this.formatterTooltip
            },
            { title: "規格", dataIndex: "spec", width: 150, ellipsis: { showTitle: false }, render: this.formatterTooltip },
            { title: "價格", dataIndex: "price", width: 100, sorter: (a, b) => a.price - b.price },
            { title: "稅", dataIndex: "tax", width: 100, sorter: (a, b) => a.tax - b.tax },
            { title: "人數", dataIndex: "numofppl", width: 100, sorter: (a, b) => a.numofppl - b.numofppl },
            { title: "附早餐?", dataIndex: "breakfast", width: 100, render: this.formatterYesOrNo, sorter: (a, b) => a.breakfast - b.breakfast },
            { title: "附晚餐?", dataIndex: "dinner", width: 100, render: this.formatterYesOrNo, sorter: (a, b) => a.dinner - b.dinner },
            { title: "可取消?", dataIndex: "refundable", width: 100, render: this.formatterYesOrNo, sorter: (a, b) => a.refundable - b.refundable },
            { title: "頁面快照", dataIndex: "url", width: 150, render: this.formatterUrl },
            { title: "上次更新", dataIndex: "updated_at", width: 200, sorter: (a, b) => new Date(a.updated_at) - new Date(b.updated_at) }
        ];

        return (
            <Drawer visible={this.props.visible} onClose={this.hide} width={1000} zIndex={100000000}>
                <Row
                    gutter={[16, 16]}
                    justify="space-between"
                    align="middle"
                    style={{
                        background: "#F2F2F2",
                        borderRadius: 10,
                        padding: 10,
                    }}
                >
                    <Col>
                        <Typography.Title level={3} style={{ margin: 0 }}>
                            價格明細
                        </Typography.Title>
                    </Col>
                </Row>
                <Row>
                    <Table
                        scroll={{ x: 'max-content' }}
                        columns={columns}
                        size="small"
                        // 抽屜是先開再等資料 (端點要 10 秒左右)，沒有這個轉圈會像當掉
                        loading={this.props.loading}
                        dataSource={this.props.details}
                        rowKey="id"
                        expandable={{
                            expandedRowRender: record => <p style={{ margin: 0 }}>{record.description}</p>,
                            rowExpandable: record => true,
                        }}
                    />
                </Row>
            </Drawer>
        );
    }
}